import { UserCumuluativeUsageData } from '../UserSubscriptionPlans/constants';
import type { UserSubscriptionBillingPeriod } from '../UserSubscriptionPlans/selectors';

export type UserCumulativeUsages = Readonly<UserCumuluativeUsageData[]>;

export type CumulativeUsageSummary = Readonly<{
  cumulativeUsages: UserCumulativeUsages;
  subscriptionId: string;
}>;

export type DailyUsage = {
  date: string;
  numLearners: number;
};

export type InstitutionDailyUsage = Readonly<DailyUsage>;

export type InstitutionDailyUsages = Readonly<InstitutionDailyUsage[]>;

export type InstitutionDailyUsageSummary = Readonly<{
  // TODO: change API response to have camelCase
  /* eslint camelcase: ["error", {allow: ["daily_usages"]}] */
  daily_usages: InstitutionDailyUsages;
  subscriptionId: string;
}>;

export enum InstitutionDailyUsageDataResponseKind {
  success = 'success',
  forbidden = 'forbidden',
}

export type InstitutionDailyUsageDataSuccess = {
  kind: InstitutionDailyUsageDataResponseKind.success;
  value: InstitutionDailyUsageSummary;
};

export type InstitutionDailyUsageDataForbidden = {
  kind: InstitutionDailyUsageDataResponseKind.forbidden;
};

export type InstitutionDailyUsageData =
  | InstitutionDailyUsageDataSuccess
  | InstitutionDailyUsageDataForbidden;

export type BillingPeriods = Readonly<UserSubscriptionBillingPeriod[]>;

export type BillingPeriodSummary = Readonly<{
  billingPeriods: BillingPeriods;
}>;
